export const calendar = {
  title: 'My Calendar',
  subtitle: 'Manage your availability and sync your calendars',
  
  calendar: {
    today: 'Today',
    month: 'Month',
    week: 'Week',
    day: 'Day',
    selectDates: 'Select dates',
    blockDates: 'Block dates',
    unblockDates: 'Unblock these dates',
    addNote: 'Add a note',
    selectEvent: 'Select an event',
    nMonths: 'months',
    oneMonth: '1 month',
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December'
    },
    days: {
      monday: 'Mon',
      tuesday: 'Tue',
      wednesday: 'Wed',
      thursday: 'Thu',
      friday: 'Fri',
      saturday: 'Sat',
      sunday: 'Sun'
    }
  },
  
  sync: {
    title: 'iCal Synchronization',
    description: 'Connect your Airbnb or PMS calendar to automatically sync your availability',
    addConnection: 'Add connection',
    noConnections: 'No connections',
    icalUrl: 'iCal URL',
    icalUrlPlaceholder: 'https://www.airbnb.com/calendar/ical/...',
    platform: 'Platform',
    platformPlaceholder: 'Ex: Airbnb, Booking.com, PMS...',
    syncNow: 'Sync now',
    lastSync: 'Last sync',
    eventsImported: 'events imported',
    status: {
      synced: 'Synced',
      pending: 'Pending',
      error: 'Error',
      syncing: 'Syncing...'
    },
    remove: 'Remove',
    edit: 'Edit'
  },
  
  exchanges: {
    title: 'Upcoming Exchanges',
    noExchanges: 'No exchanges scheduled',
    viewProfile: 'View profile',
    sendMessage: 'Send message',
    confirm: 'Confirm',
    decline: 'Decline',
    cancel: 'Cancel',
    guests: 'guests',
    status: {
      confirmed: 'Confirmed',
      pending: 'Pending',
      proposal: 'Proposal',
      blocked: 'Blocked'
    }
  },
  
  legend: {
    title: 'Legend',
    available: 'Available',
    confirmed: 'Confirmed exchange',
    pending: 'Pending request',
    proposal: 'Proposal',
    blocked: 'Blocked dates'
  },
  
  blockModal: {
    title: 'Block dates',
    reason: 'Reason (optional)',
    reasonPlaceholder: 'Ex: Renovation, personal vacation...',
    from: 'From',
    to: 'To',
    block: 'Block',
    cancel: 'Cancel'
  },
  
  notifications: {
    datesBlocked: 'Dates blocked successfully',
    datesUnblocked: 'Dates unblocked successfully',
    syncSuccess: 'Sync successful',
    syncError: 'Sync error',
    connectionAdded: 'Connection added successfully',
    connectionRemoved: 'Connection removed',
    exchangeConfirmed: 'Exchange confirmed',
    exchangeDeclined: 'Exchange declined'
  },

  details: 'Details',
  upcomingExchanges: 'Upcoming exchanges',
  noExchangesPlanned: 'No exchanges planned',
  daysSelected: 'days selected',
  daySelected: 'day selected',
  from: 'From',
  to: 'to',
  reasonOptional: 'Reason (optional)',
  reasonPlaceholder: 'Ex: Personal vacation...',
  block: 'Block',
  cancel: 'Cancel',
  namePlaceholder: 'Name (ex: Airbnb)',
  filters: 'Filters',
  actions: 'Actions',
  connections: 'Connections'
};
